import axios from "axios";
import React, { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import { Link, useHistory } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Select from "react-select";
import swal from "sweetalert";
import plus from "../../assets/Icon/plus.svg";
import { BASE_URL } from "../Const/Url";
import DeleteIcon from "../CustomCommons/DeleteIcon";
import EditIcon from "../CustomCommons/EditIcon";
import Loader from "../CustomCommons/Loader";
import NextIcon from "../CustomCommons/NextIcon";
import Permission from "../CustomCommons/Permission";
import PreviousIcon from "../CustomCommons/PreviousIcon";
import kaarujLogo from "../../assets/Icon/KAARUJ 1.png";
import {
  can_change_products,
  can_view_invoice,
  has_permissions,
} from "../CustomCommons/utils";
import ViewIcon from "../CustomCommons/ViewIcon";
import * as path from "../Routes/RoutePaths";
import { showToast } from "../../utils/ToastHelper";
import { logout_func2 } from "../Const/logoutCommon";
import CustomModal from "../CustomCommons/CustomModal";
import ViewProduct from "../inventory/product/ViewProduct";
import { Eye, Share } from "phosphor-react";
import HelperExportComponent from "../../utils/HelperExportComponent";

const ThemeProductList = () => {
  const [isLoading, SetisLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPdId, setModalPdId] = useState(null);
  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");
  const cRef = useRef();
  const [query, setQuery] = useState("");
  const [renking, setRenking] = useState("");

  const [adminOrOutlet, setAdminOrOutlet] = useState("");
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [outletList, setOutletList] = useState([]);
  const [homeDecor, setHomedecor] = useState([]);
  const [Instyle, setInstyle] = useState([]);
  const [category, setCategory] = useState(null);
  const [theme, setTheme] = useState([]);
  const [themeId, setThemeId] = useState(null);
  /**
   * Selected product ids for "remove from theme" action.
   * We intentionally keep this local to this page only.
   */
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [isRemovingProducts, setIsRemovingProducts] = useState(false);

  // ofset code
  const [totalData, setTotalData] = useState(0);
  const [items_data, setItems_data] = useState([]);
  const [total_item, setTotal_item] = useState(0);
  const [isLoading2, SetisLoading2] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);

  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const limit = 10;
  const [OnlogoutHide, setOnlogoutHide] = useState(0);
  const item_limit = pageNumber * limit;
  const this_page_items_show =
    item_limit > total_item ? total_item : item_limit;
  const page_show_start = item_limit - limit + 1;
  const pageCount = Math.ceil(total_item / limit);
  const indexOfLastPost = pageCount < pageNumber ? limit : pageNumber * limit;
  const offset = pageCount < pageNumber ? 0 : indexOfLastPost - limit;

  const [source, setSource] = useState("");

  const apiFunction = (url) => {
    axios
      .get(url)
      .then((res) => {
        setTotal_item(res.data?.data?.count);
        setTotalData(res.data?.data?.count);
        setItems_data(res.data?.data?.results);
        setNextUrl(res.data?.data?.next);
        setPrevUrl(res.data?.data?.previous);

        // console.log(res.data);
        SetisLoading(false);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          // history.push('/login')
          logout_func2(setOnlogoutHide, history);
        }
      });
  };

  /**
   * Products on the current page that are selectable (have numeric id).
   * We use this for "Select all" behavior.
   */
  const selectableProductIdsOnPage = (items_data || [])
    .map((product) => product?.id)
    .filter((id) => Number.isInteger(id));

  const areAllProductsOnPageSelected =
    selectableProductIdsOnPage.length > 0 &&
    selectableProductIdsOnPage.every((id) => selectedProductIds.includes(id));

  const isSelectAllIndeterminate =
    selectedProductIds.length > 0 &&
    !areAllProductsOnPageSelected &&
    selectableProductIdsOnPage.some((id) => selectedProductIds.includes(id));

  const toggleSelectAllOnPage = (shouldSelectAll) => {
    if (shouldSelectAll) {
      setSelectedProductIds(selectableProductIdsOnPage);
      return;
    }
    setSelectedProductIds([]);
  };

  const toggleSelectSingleProduct = (productId) => {
    if (!Number.isInteger(productId)) return;
    setSelectedProductIds((prevIds) => {
      const isAlreadySelected = prevIds.includes(productId);
      if (isAlreadySelected) return prevIds.filter((id) => id !== productId);
      return [...prevIds, productId];
    });
  };

  /**
   * Remove selected products from the currently selected theme.
   * API: POST api/v1/inventory/inventory/themes/remove_products_from_theme/
   * Payload: { theme_id, product_ids }
   */
  const handleRemoveSelectedProductsFromTheme = () => {
    if (!themeId) {
      showToast("error", "Please select a theme first.");
      return;
    }
    if (!selectedProductIds.length) return;

    swal({
      title: "Remove selected products?",
      text: `This will remove ${selectedProductIds.length} product(s) from this theme.`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willRemove) => {
      if (!willRemove) return;

      setIsRemovingProducts(true);
      axios
        .post(
          `${BASE_URL}api/v1/inventory/inventory/themes/remove_products_from_theme/`,
          {
            theme_id: themeId,
            product_ids: selectedProductIds,
          }
        )
        .then((res) => {
          // Some endpoints return {status: true/false}. If absent, treat 2xx as success.
          if (res?.data?.status === false) {
            showToast(
              "error",
              res?.data?.message || "Failed to remove products from theme."
            );
            return;
          }
          showToast("success", "Product(s) removed from theme.");
          setSelectedProductIds([]);

          // Reload current theme with current paging/search state
          apiFunction(
            `${BASE_URL}${"api/v1/inventory/inventory/products/"}?limit=${limit}&offset=${offset}&search=${query}` +
              `${themeId ? `&theme=${themeId}` : ""}`
          );
        })
        .catch((err) => {
          const status = err?.response?.status;
          if (status === 401) {
            logout_func2(setOnlogoutHide, history);
            return;
          }
          const message =
            err?.response?.data?.message ||
            err?.response?.data?.errors?.non_field_errors?.[0] ||
            "Failed to remove products from theme.";
          showToast("error", message);
        })
        .finally(() => setIsRemovingProducts(false));
    });
  };

  const getCategory = () => {
    const url = `${BASE_URL}api/v1/inventory/inventory/themes/?limit=100`;

    axios
      .get(url)
      .then((res) => {
        // console.log(res.data.data.results);
        const result = res.data.data.results;
        const options = result.map((curr) => ({
          label: curr.name,
          value: curr.id,
        }));
        setTheme(options);
      })
      .catch((err) => {
        const message = JSON.parse(err.request.response).message;
        // console.log(err.request.response);
        if (
          message === "Invalid token." ||
          JSON.parse(err.request.response).code === 401
        ) {
          // history.push('/login')
          logout_func2(setOnlogoutHide, history);
        }
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  // Clear selection when switching themes.
  useEffect(() => {
    setSelectedProductIds([]);
  }, [themeId]);

  // Keep selection in sync with current page data (avoid removing invisible/old items).
  useEffect(() => {
    const selectableIdSet = new Set(selectableProductIdsOnPage);
    setSelectedProductIds((prevIds) => prevIds.filter((id) => selectableIdSet.has(id)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items_data]);

  // useEffect(() => {
  //   if (!themeId) {
  //     setTotal_item(0);
  //     setTotalData(0);
  //     setItems_data([]);
  //     setNextUrl(null);
  //     setPrevUrl(null);
  //     SetisLoading(false);
  //     return;
  //   }
  //   apiFunction(
  //     `${BASE_URL}${"api/v1/inventory/inventory/products/"}?limit=${limit}&offset=${offset}&search=${query}` +
  //       `${themeId ? `&theme=${themeId}` : ""}`
  //   );
  // }, [themeId]);

  const handlePaginationPrevious = () => {
    apiFunction(prevUrl);
    setPageNumber((prev) => {
      if (prev > 1) {
        return prev - 1;
      } else {
        return prev;
      }
    });
    // SetisLoading(false)
  };
  const handlePaginationNext = () => {
    // SetisLoading(true);
    apiFunction(nextUrl);
    setPageNumber((prev) => prev + 1);
    // SetisLoading(false)
  };
  const handleChangeCurrentPage = (val) => {
    setPageNumber(val);
  };

  useEffect(() => {
    if (pageCount !== 0) {
      if (pageCount < pageNumber) {
        setPageNumber(pageCount);
      }
    }
  }, [pageCount]);

  useEffect(() => {
    if (!themeId) {
      setTotal_item(0);
      setTotalData(0);
      setItems_data([]);
      setNextUrl(null);
      setPrevUrl(null);
      SetisLoading(false);
      return;
    }
    // call only when Theme ID exists
    apiFunction(
      `${BASE_URL}${"api/v1/inventory/inventory/products/"}?limit=${limit}&offset=${offset}&search=${query}` +
        `${themeId ? `&theme=${themeId}` : ""}`
    );
  }, [pageNumber, query, themeId]);

  // ofset code

  const history = useHistory();
  const handleCategory = (newVal, action) => {
    setThemeId(parseInt(newVal.value));
    console.log(newVal.value, "183");
  };
  const openModal = (id) => {
    setModalPdId(id);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div style={{ height: "100vh"}} className="h-screen ">
      <div className="mx-3 my-3">
        <div className="cotagorey-head ">
          <div>
            <h3>Theme Product List </h3>
            <input
              style={{ color: "black" }}
              type="text"
              className="filter-input"
              placeholder="Search here"
              onChange={(e) => {
                setQuery(e.target.value.toLocaleLowerCase());
              }}
            />
          </div>

          <div className="filter_div me-3">
            <div className="d-flex align-items-center">
              <div className="me-2 mb-3 mb-md-0 ">
                <p className="">Category :</p>
                <div
                  className="sl"
                  style={{ width: "180px", marginTop: "-15px" }}
                >
                  <Select
                    onChange={handleCategory}
                    options={theme}
                    placeholder="---Select---"
                  />
                </div>
              </div>
              <div className="me-2 mt-3 mb-md-0 ">
                <div
                  className="button-div"
                  onClick={() =>
                    history.push(path.add_theme_product)
                  }
                >
                  <img src={plus} alt="" />
                  <span>Add Product</span>
                </div>
              </div>

              {themeId && selectedProductIds.length > 0 && (
                <div className="me-2 mt-3 mb-md-0 ">
                  <button
                    className="btn text-light"
                    style={{
                      background: "black",
                      cursor: isRemovingProducts ? "not-allowed" : "pointer",
                      color: "white",
                      height: "40px",
                      borderRadius: "6px",
                      whiteSpace: "nowrap",
                    }}
                    disabled={isRemovingProducts}
                    onClick={handleRemoveSelectedProductsFromTheme}
                  >
                    {isRemovingProducts
                      ? "Removing..."
                      : `Remove (${selectedProductIds.length})`}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* categorey list table */}
        <div className="mt-4" style={{ display: "block", overflowX: "auto" }}>
          <table className="table_my">
            <thead
              className="bg-dark text-white head-row"
              style={{ height: "50px", borderTopLeftRadius: "20px !important" }}
            >
              <tr className="">
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "70px",
                    textAlign: "center",
                  }}
                >
                  <input
                    type="checkbox"
                    disabled={!themeId || selectableProductIdsOnPage.length === 0}
                    checked={areAllProductsOnPageSelected}
                    ref={(el) => {
                      if (el) el.indeterminate = isSelectAllIndeterminate;
                    }}
                    onChange={(e) => toggleSelectAllOnPage(e.target.checked)}
                  />
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                    textAlign: "start",
                    paddingLeft: "10px",
                  }}
                >
                  #ID
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                    textAlign: "start",
                    paddingLeft: "10px",
                  }}
                >
                  Thumbnail
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "187px",
                  }}
                >
                  Name
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "187px",
                  }}
                >
                  SKU
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "180px",
                  }}
                >
                  Theme
                </th>
                <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "180px",
                  }}
                >
                  Category
                </th>

                {/* <th
                  style={{
                    fontSize: "16px",
                    fontWeight: "normal",
                    width: "100px",
                  }}
                >
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody className="tb">
              {items_data.length > 0 && items_data ? (
                items_data.map((category, index) => (
                  <tr className="table-row " key={index}>
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        disabled={!Number.isInteger(category?.id) || !themeId}
                        checked={
                          Number.isInteger(category?.id)
                            ? selectedProductIds.includes(category.id)
                            : false
                        }
                        onChange={() => toggleSelectSingleProduct(category?.id)}
                      />
                    </td>
                    <td>
                      <p className="ms-3 my-auto">{index + 1}</p>
                    </td>
                    <td>
                      <img
                        width={50}
                        style={{ margin: "6px 0px !important" }}
                        height={50}
                        src={category.thumb_url}
                        alt=""
                      />
                    </td>
                    <td>{category.name}</td>
                    <td>{category.sku}</td>
                    <td>{category.theme_name ? category.theme_name : "N/A"}</td>
                    <td>
                      {category?.category_details &&
                      category?.category_details[0]?.name
                        ? category?.category_details[0]?.name
                        : "N/A"}
                    </td>

                    {/* <td className="action">
                      <div className="d-flex gap-3">
                        <div
                          className="edit-del blue"
                          onClick={() => openModal(category?.slug)}
                        >
                          <ViewIcon />
                        </div>
                        {has_permissions(can_change_products) ? (
                          <div
                            className="edit-del green"
                            onClick={() => {
                              history.push(
                                `/inventory/edit-product/${category?.slug}`
                              );
                            }}
                          >
                            <EditIcon />
                          </div>
                        ) : (
                          <div
                            className="edit-del green"
                            onClick={() =>
                              swal("Sorry, You are not able to edit product.")
                            }
                          >
                            <EditIcon />
                          </div>
                        )}
                      </div>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colspan="7">
                    <div className="not_found d-flex justify-content-center align-items-center py-4">
                      <h4 className="my-4">No Data Found</h4>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* entites and paggination */}
        {totalData > 0 && (
          <div className="row pag" style={{ marginTop: "30px" }}>
            <div className="col-6 col-md-5">
              <p
                className="inter"
                style={{ color: "#AEAEB2", fontSize: "16px" }}
              >
                Total Entries:{" "}
                <span style={{ color: "black", fontSize: "14px" }}>
                  {totalData}
                </span>
                <span className="ms-2"></span>
                Total Page:{" "}
                <span style={{ color: "black", fontSize: "14px" }}>
                  {Math.ceil(totalData / 10)}
                </span>
              </p>
            </div>
           
            <div className="col-12 col-md-6 d-flex paggination-button">
              <>
                <div className="row lead_pagination bg-transparent">
                  <div className="col-12 col-lg-6 d-flex justify-content-lg-end justify-content-md-end  col-md-6 col-sm-6  col-xs-12 pagination_container">
                    <nav aria-label="...">
                      <ul className="pagination pagination-sm">
                        {!isLoading ? (
                          <li className="page-item ">
                            {prevUrl !== null ? (
                              <Link
                                onClick={handlePaginationPrevious}
                                className={` ${
                                  prevUrl === null ? "disabled" : ""
                                } page-link pagination_texts  pagination_btn font_size_for_small py-1 mt-1 me-3 a`}
                                to="#"
                                tabindex="-1"
                              >
                                <PreviousIcon />
                              </Link>
                            ) : (
                              <Link
                                onClick={() =>
                                  showToast("success", "You are on first page")
                                }
                                className={` ${
                                  prevUrl === null ? "disabled" : ""
                                } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                                to="#"
                                tabindex="-1"
                              >
                                <PreviousIcon />
                              </Link>
                            )}
                          </li>
                        ) : (
                          <li className="page-item ">
                            <Link
                              className={` ${
                                prevUrl === null ? "disabled" : ""
                              } page-link pagination_texts pagination_btn font_size_for_small me-3 py-1 mt-1 a`}
                              to="#"
                              tabindex="-1"
                            >
                              <PreviousIcon />
                            </Link>
                          </li>
                        )}

                        {[...Array(pageCount === null ? 1 : pageCount)].map(
                          (elem, index) => (
                            <li
                              className="page-item"
                              style={{
                                display: `${
                                  index + 1 !== pageNumber ? "none" : "block"
                                }`,
                              }}
                            >
                              {/*  style={{
                    display: `${index + 1 !== pageNumber ? "none" : "block"}`,
                  }} */}
                              {/* setPageNumber(prev=> prev - 1) */}

                              <Link
                                onClick={() =>
                                  handleChangeCurrentPage(index + 1)
                                }
                                className={`${
                                  index + 1 == pageNumber
                                    ? "paginationActive"
                                    : ""
                                } page-link lead_page_link lead_page_link1 font_size_for_small pagination_texts px-2 text-dark`}
                                to="#"
                              >
                                <span className="px-1 py-1">{pageNumber}</span>
                              </Link>
                            </li>
                          )
                        )}
                        {!isLoading ? (
                          <li className="page-item">
                            {nextUrl !== null ? (
                              <Link
                                onClick={handlePaginationNext}
                                className={`${
                                  nextUrl === null ? "disabled" : ""
                                } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                to="#"
                              >
                                <NextIcon />{" "}
                              </Link>
                            ) : (
                              <Link
                                onClick={() =>
                                  showToast("success", "You are on last page")
                                }
                                className={`${
                                  nextUrl === null ? "disabled" : ""
                                } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                                to="#"
                              >
                                <NextIcon />
                              </Link>
                            )}
                          </li>
                        ) : (
                          <li className="page-item">
                            <Link
                              className={`${
                                nextUrl === null ? "disabled" : ""
                              } page-link pagination_btn font_size_for_small pagination_texts py-1 mt-1 ms-3 a`}
                              to="#"
                            >
                              <NextIcon />
                            </Link>
                          </li>
                        )}
                      </ul>
                    </nav>
                  </div>
                </div>
              </>
            </div>
          </div>
        )}
      </div>
      <CustomModal isOpen={isModalOpen} onClose={closeModal}>
        {modalPdId ? <ViewProduct pdId={modalPdId} /> : <Loader />}
      </CustomModal>
    </div>
  );
};

export default ThemeProductList;
